// THOMAS COIN — route v3. Token identity is intentionally separate from route geometry.

export const A = {
  plates: {
    s00d: '/assets/plates/keyframes--s00-dawn-departure-desktop-v01.webp',
    s00m: '/assets/plates/keyframes--s00-dawn-departure-mobile-v01.webp',
    s04: '/assets/plates/keyframes--s04-tunnel-threshold-desktop-v01.webp',
    s07: '/assets/cinematic-v3/s07-final.webp',
    s07m: '/assets/cinematic-v3/s07-final-mobile-v2.webp',
  },
  train: {
    sideThomas: '/assets/train/trains--side-thomas-alpha-v01.webp',
    sideCoachRed: '/assets/train/passenger-coach-red-side-alpha-v01.webp',
    sideCoachGreen: '/assets/train/passenger-coach-green-side-alpha-v01.webp',
    sideWagonEmpty: '/assets/train/value-wagon-empty-side-alpha-v01.webp',
    sideWagonHalf: '/assets/train/value-wagon-half-side-alpha-v01.webp',
    sideWagonFull: '/assets/train/value-wagon-full-side-alpha-v01.webp',
    beThomas: '/assets/train/trains--birdseye-thomas-alpha-v01.webp',
    beCoachRed: '/assets/train/passenger-coach-red-birdseye-alpha-v01.webp',
    beCoachGreen: '/assets/train/passenger-coach-green-birdseye-alpha-v01.webp',
    beWagonEmpty: '/assets/train/value-wagon-empty-birdseye-alpha-v01.webp',
    beWagonHalf: '/assets/train/value-wagon-half-birdseye-alpha-v01.webp',
    beWagonFull: '/assets/train/value-wagon-full-birdseye-alpha-v01.webp',
  },
  ui: {
    coinFace: '/assets/ui/coin-engine-face-v01.png',
    lever: '/assets/ui/points-lever-v01.png',
  },
  fx: {
    steamH: '/assets/fx/steam-wisp-horizontal-screen-v01.png',
    steamV: '/assets/fx/steam-puff-vertical-screen-v01.png',
    bloom: '/assets/fx/signal-green-bloom-screen-v01.png',
    soot: '/assets/fx/soot-dust-screen-v01.png',
    sparks: '/assets/fx/wheel-sparks-screen-v01.png',
    rain: '/assets/fx/rain-diagonal-screen-v01.png',
    fog: '/assets/fx/valley-fog-screen-v01.png',
  },
  tickets: {
    landscape: '/assets/tickets/passenger-ticket-social-landscape-alpha-v01.webp',
    portrait: '/assets/tickets/passenger-ticket-mobile-portrait-alpha-v01.webp',
  },
  tex: {
    brick: '/assets/textures/brick-soot-v01.webp',
  },
};

export const DESTINATIONS = [
  { id: 'S_BONK_FOUNDRY', sceneKey: 'bonk-foundry', tokenId: 'bonk', ticker: '$BONK', name: 'BONK', place: 'SHIBA FOUNDRY', threshold: 50000, progress: 0.08, line: 'THE DOG CLOCKED IN BEFORE SUNRISE.', sign: 'SHIBA FOUNDRY', motif: 'Cream shiba foundry, bone gantries and furnace halls' },
  { id: 'S_WIF_RIDGE', sceneKey: 'wif-ridge', tokenId: 'wif', ticker: '$WIF', name: 'DOGWIFHAT', place: 'WINDCUT RIDGE', threshold: 100000, progress: 0.16, line: 'HAT ON. HEADWIND IGNORED.', sign: 'WINDCUT RIDGE', motif: 'Knitted-hat mountain arch and alpine viaduct' },
  { id: 'S_CUPSEY_PLATFORM', sceneKey: 'cupsey-platform', tokenId: 'cupsey', ticker: '$CUPSEY', name: 'CUPSEY', place: 'PUMP PLATFORM', threshold: 250000, progress: 0.25, line: 'THE CUP IS FULL. THE PUMPS ARE LOUD.', sign: 'PUMP PLATFORM', motif: 'Crowned cup tower and refreshment pumping works' },
  { id: 'S_POPCAT_QUARRY', sceneKey: 'popcat-quarry', tokenId: 'popcat', ticker: '$POPCAT', name: 'POPCAT', place: 'ECHO QUARRY', threshold: 500000, progress: 0.34, line: 'THE TUNNEL SAID POP. NORMAL SERVICE.', sign: 'ECHO QUARRY', motif: 'Cat-mouth quarry tunnel and echo horns' },
  { id: 'S_FARTCOIN_GASWORKS', sceneKey: 'fartcoin-gasworks', tokenId: 'fartcoin', ticker: '$FARTCOIN', name: 'FARTCOIN', place: 'GASWORKS MARSH', threshold: 1000000, progress: 0.43, line: 'PRESSURE UP. QUESTIONS DOWN.', sign: 'GASWORKS MARSH', motif: 'Marsh pressure tanks, gauges and vapor works' },
  { id: 'S_JIMOTHY_SALVAGE', sceneKey: 'jimothy-salvage', tokenId: 'jimothy', ticker: '$JIMOTHY', name: 'JIMOTHY', place: 'NIGHT SALVAGE', threshold: 3000000, progress: 0.53, line: 'THE RACCOON TOOK THE NIGHT SHIFT.', sign: 'NIGHT SALVAGE', motif: 'Raccoon-mask warehouse and striped-tail cranes' },
  { id: 'S_BOME_ARCHIVE', sceneKey: 'bome-archive', tokenId: 'bome', ticker: '$BOME', name: 'BOOK OF MEME', place: 'ARCHIVE CITY', threshold: 10000000, progress: 0.64, line: 'THE INTERNET FILED IT UNDER IMPORTANT.', sign: 'ARCHIVE CITY', motif: 'Book towers, brass index machines and paper vaults' },
  { id: 'S_KET_OBSERVATORY', sceneKey: 'ket-observatory', tokenId: 'ket', ticker: '$KET', name: 'KET', place: 'OBSERVATORY JCT.', threshold: 30000000, progress: 0.75, line: 'NINE LIVES. ONE COLD PLATFORM.', sign: 'OBSERVATORY JUNCTION', motif: 'Cat-ear telescope domes above a snowy junction' },
  { id: 'S_BLACK_BULL_GRADE', sceneKey: 'black-bull-grade', tokenId: 'black-bull', ticker: '$ANSEM', name: 'BLACK BULL', place: 'IRON MOUNTAIN', threshold: 100000000, progress: 0.87, line: 'THE BULL OWNS THE GRADE.', sign: 'IRON MOUNTAIN GRADE', motif: 'Bull-carved cliff, horn viaduct and iron switchback' },
  { id: 'S_TROLL_BRIDGE', sceneKey: 'troll-bridge', tokenId: 'troll', ticker: '$TROLL', name: 'TROLL', place: 'LAST BRIDGE', threshold: 1000000000, progress: 1, line: 'LAST BRIDGE. SAME INTERNET.', sign: 'LAST BRIDGE', motif: 'Stone troll bridge and salt-worn coastal fortress' },
];

export const STATIONS = [
  { id: 'S_DEPOT', name: 'THOMAS DEPOT', progress: 0, mcap: 0, notice: 'THE TRENCHES ARE BOARDING.' },
  ...DESTINATIONS.map((stop) => ({ id: stop.id, name: stop.place, progress: stop.progress, mcap: stop.threshold, notice: stop.line })),
];

// Normalized 2:1 world coordinates. This is the canonical forward route.
export const ROUTE_PATH = [
  [52,100],[51,94],[51,88],[52,82],[54,76],[52,72],[47,68],[42,63],[38,58],[38,54],
  [40,49],[46,44],[52,42],[47,41],[42,39],[37,36],[32,32],[27,27],[22,24],[19,22],
  [16,20],[14,17],[14,14],[17,12],[21,14],[23,17],[24,20],[28,20],[34,17],[40,14],
  [46,13],[50,16],[51,20],[57,23],[63,26],[69,31],[75,33],[82,35],[88,35],[84,39],
  [78,42],[75,47],[76,53],[80,58],[84,62],[85,68],[84,75],[82,82],[78,87],[72,87],
  [67,83],[64,78],[59,75],[54,74],[52,78],[51,84],[52,92],[52,100],
];

const routeSegments = [];
let routeLength = 0;
for (let i = 0; i < ROUTE_PATH.length - 1; i += 1) {
  const [x1, y1] = ROUTE_PATH[i];
  const [x2, y2] = ROUTE_PATH[i + 1];
  const length = Math.hypot(x2 - x1, (y2 - y1) * 0.5625);
  routeSegments.push(length);
  routeLength += length;
}

export function pointAtProgress(value) {
  const p = Math.max(0, Math.min(1, value));
  let target = p * routeLength;
  for (let i = 0; i < routeSegments.length; i += 1) {
    if (target <= routeSegments[i] || i === routeSegments.length - 1) {
      const t = routeSegments[i] ? target / routeSegments[i] : 0;
      const [x1, y1] = ROUTE_PATH[i];
      const [x2, y2] = ROUTE_PATH[i + 1];
      return {
        x: x1 + (x2 - x1) * t,
        y: y1 + (y2 - y1) * t,
        angle: (Math.atan2((y2 - y1) * 0.5625, x2 - x1) * 180) / Math.PI,
      };
    }
    target -= routeSegments[i];
  }
  return { x: ROUTE_PATH[0][0], y: ROUTE_PATH[0][1], angle: 0 };
}

export function fmtUsd(n) {
  if (n === null || n === undefined || Number.isNaN(n)) return '—';
  if (n >= 1e9) return `$${(n / 1e9).toFixed(2)}B`;
  if (n >= 1e6) return `$${(n / 1e6).toFixed(2)}M`;
  if (n >= 1e3) return `$${(n / 1e3).toFixed(1)}K`;
  return `$${Math.round(n)}`;
}

export function fmtTime(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '—' : `${String(d.getUTCHours()).padStart(2, '0')}:${String(d.getUTCMinutes()).padStart(2, '0')} UTC`;
}
